const API_URL = window.location.origin + '/wp-json';
const INCLUDES_URL = window.location.origin + '/mw-includes';
const FORECAST_GRAPH_URL = 'https://4138f71b245bd703cbc14dd5dfac40da.s3.amazonaws.com/forecastgraph/';
const SCRAPED_SNOW_REPORTS_URL = 'https://firebasestorage.googleapis.com/v0/b/mountainwatch-1.appspot.com/o/snow-reports%2F';

export function getGroundReport(id) {
    return fetch(INCLUDES_URL + '/snowreport/' + id + '.json', {
        headers: {
            'Cache-Control': 'no-cache'
        }
    }).then(response => response.json());
}

export function getSnowReport(id) {
    return fetch(INCLUDES_URL + '/snowdata/' + id + '.json', {
        headers: {
            'Cache-Control': 'no-cache'
        }
    }).then(response => response.json());
}

export function getScrappedSnowReport(id) {
        return fetch(SCRAPED_SNOW_REPORTS_URL + id + '.json?alt=media', {
            headers: {
                // 'Cache-Control': 'no-cache'
            }
        }).then(response => response.json());
}